import { AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, Input, NgZone, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subject, debounceTime, takeUntil } from 'rxjs';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { SignalrService } from 'src/app/Service/signalr.service';
import { StateManagementMenucarService } from 'src/app/Service/state-management-menucar.service';
import { IAlarm, ILocationChanged } from 'src/app/shared/models/signalR-model';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';

declare let $: any;

type Scope = 'all' | 'official' | 'alarms';
type StatusFilter = 'all' | 'active' | 'inactive' | 'area';
type SortMode = 'default' | 'name' | 'recent' | 'status';
type VehicleState = 'active' | 'activeAlt' | 'inactive' | 'noHistory';

interface Vehicle {
  strUnitID?: string;
  strUnitId?: string;
  strFullName?: string;
  strFullName2?: string;
  strVehicleNo?: string;
  bOfficial?: boolean;
  bOnline?: boolean;
  bNoMobileHistory?: boolean;
  tiOfficialStatus?: number | null;
  tiDeviceStatus?: number;
  tiMobileType?: number | string;
  strDate?: string;
  strTime?: string;
  strTimeAge?: string;
  strIconName?: string;
  [key: string]: any;
}

const STATUS_RADIO_ID: Record<StatusFilter, string> = {
  all: 'radio1',
  active: 'radio2',
  inactive: 'radio3',
  area: 'radio5',
};

const RADIO_ID_STATUS: Record<string, StatusFilter> = {
  radio1: 'all',
  radio2: 'active',
  radio3: 'inactive',
  radio5: 'area',
};

const STATE_LABELS: Record<VehicleState, string> = {
  active: 'فعال',
  activeAlt: 'فعال',
  inactive: 'غیرفعال',
  noHistory: 'بدون سابقه',
};

const MAX_ALARMS = 100;
const SEARCH_DEBOUNCE_MS = 200;
const LOCATION_FLUSH_MS = 500;
const FLASH_MS = 1600;
const EXPORT_FILE_NAME = 'لیست خودرو ها.xlsx';

function normalize(value: unknown): string {
  return String(value ?? '')
    .toLowerCase()
    .replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(d)))
    .replace(/ي/g, 'ی')
    .replace(/ك/g, 'ک');
}

function definedOnly<T extends object>(obj: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== undefined),
  ) as Partial<T>;
}

@Component({
  selector: 'menu_car',
  templateUrl: './menu_carcomponent.html',
  styleUrls: ['./menu_carcomponent.css'],
})
export class MenuCarComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy{
  @HostBinding('class') readonly hostClass = 'Menucar';

  @Input() item: any;
  @Input() GeoFence: any;
  @Input() dataPolygans: any;
  @Input() dataWorkAz: any;
  @Input() dataWorkTa: any;
  @Output() locationTable = new EventEmitter<any>();
  @Output() carIdOut = new EventEmitter<any>();
  @Output() carGroup = new EventEmitter<any>();

  readonly scopeTabs: { key: Scope; label: string }[] = [
    { key: 'all', label: 'همه' },
    { key: 'official', label: 'خدماتی' },
    { key: 'alarms', label: 'وقایع ردیاب' },
  ];

  readonly sortOptions: { key: SortMode; label: string }[] = [
    { key: 'default', label: 'پیش‌فرض' },
    { key: 'name', label: 'نام' },
    { key: 'recent', label: 'جدیدترین' },
    { key: 'status', label: 'وضعیت' },
  ];

  statusChips: { key: StatusFilter; label: string }[] = [];

  access: any;
  isDesktop: boolean;
  isMobile: boolean;
  carCount = 0;
  vehicleTypes: { tiMobileType: number | string; strComment: string }[] = [];

  scope: Scope = 'all';
  statusFilter: StatusFilter = 'all';
  vehicleType = '-1';
  searchTerm = '';
  sortMode: SortMode = 'default';

  cars: Vehicle[] | null = null; // همه‌ی خودروهای ورودی
  visibleCars: Vehicle[] = []; // خروجی بعد از فیلتر/جستجو/مرتب‌سازی
  counts: Record<StatusFilter, number> = {
    all: 0,
    active: 0,
    inactive: 0,
    area: 0,
  };
  areaLoading = false;

  alarms: IAlarm[] = [];
  hubConnected = false;

  selectedUnitId: string | null = null;
  expandedUnitId: string | null = null;

  // ---- داخلی ----
  private areaCars: Vehicle[] = [];
  private readonly destroy$ = new Subject<void>();
  private readonly search$ = new Subject<void>();
  private readonly carsByUnitId = new Map<string, Vehicle[]>();
  private readonly pendingLocations = new Map<string, ILocationChanged>();
  private readonly flashes = new Map<string, string>();
  private flashSeq = 0;
  private readonly flashTimers = new Map<string,ReturnType<typeof setTimeout>>();
  private readonly plateCache = new Map<string, string>();
  private flushTimer?: ReturnType<typeof setTimeout>;
  private restoreEmitTimer?: ReturnType<typeof setTimeout>;
  private hubListening = false;
  private hasRestoredState = false;
  private analysisCarId: string | number = 0;
  private reportType: number | null = null;

  constructor(
    private readonly notifyService: NotificationService,
    private readonly router: Router,
    private readonly otherService: OtherService,
    private readonly host: ElementRef<HTMLElement>,
    private readonly deviceService: DeviceDetectorService,
    private readonly stateManagement: StateManagementMenucarService,
    private readonly gurdService: GurdServiceService,
    private readonly signalR: SignalrService,
    private readonly ngZone: NgZone,
  ) {
    this.isDesktop = this.deviceService.isDesktop();
    this.isMobile = this.deviceService.isMobile();
    this.restoreState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['item'] && this.item) {
      this.cars = this.item;
      this.rebuildUnitIndex();
      this.applyFilters();
    }
    if (changes['GeoFence'] && this.statusFilter === 'area') {
      void this.loadAreaCars();
    }
  }

  ngOnInit(): void {
    this.watchHubConnection();

    this.search$
      .pipe(debounceTime(SEARCH_DEBOUNCE_MS), takeUntil(this.destroy$))
      .subscribe(() => this.applyFilters());

    if (!this.isDesktop) this.close();

    this.access = JSON.parse(this.secret('menu'));
    this.statusChips = [
      { key: 'all', label: 'همه' },
      { key: 'active', label: 'فعال' },
      { key: 'inactive', label: 'غیرفعال' },
      ...(this.access?.bEnableGeoFance
        ? [{ key: 'area' as StatusFilter, label: 'محدوده' }]
        : []),
    ];

    void this.loadVehicleTypes();
    void this.loadCarCount();

    if (this.hasRestoredState) {
      // نقشه کمی دیرتر آماده می‌شود؛ لیست ذخیره‌شده را با تأخیر به آن می‌دهیم
      this.restoreEmitTimer = setTimeout(() => this.carGroup.emit(this.visibleCars),700);

      if (this.statusFilter === 'area') void this.loadAreaCars();
    }
  }

  ngAfterViewInit(): void {
    this.bindExternalModalEvents();
  }

  ngOnDestroy(): void {
    $('#reporetArea, #enterAnimateArea, [name="analysis"]').off('.menuCar');
    clearTimeout(this.flushTimer);
    clearTimeout(this.restoreEmitTimer);
    this.flashTimers.forEach((timer) => clearTimeout(timer));
    this.destroy$.next();
    this.destroy$.complete();
  }

  // ======================= نمایش و فیلتر =======================

  get isLoading(): boolean {
    return this.cars === null || this.areaLoading;
  }

  get hasActiveFilters(): boolean {
    return (!!this.searchTerm || this.vehicleType !== '-1' || this.statusFilter !== 'all');
  }

  setScope(scope: Scope): void {
    if (scope === this.scope) return;
    this.scope = scope;
    this.statusFilter = 'all';
    this.vehicleType = '-1';
    this.searchTerm = '';
    this.applyFilters();
  }

  setStatusFilter(filter: StatusFilter): void {
    if (filter === this.statusFilter) return;
    this.statusFilter = filter;
    if (filter === 'area') void this.loadAreaCars();
    else this.applyFilters();
  }

  onSearch(value: string): void {
    this.searchTerm = value ?? '';
    this.search$.next();
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.applyFilters();
  }

  onTypeChange(value: string): void {
    this.vehicleType = String(value);
    this.applyFilters();
  }

  onSortChange(mode: SortMode): void {
    this.sortMode = mode;
    this.applyFilters(false);
  }

  resetFilters(): void {
    this.statusFilter = 'all';
    this.vehicleType = '-1';
    this.searchTerm = '';
    this.applyFilters();
  }

  readonly trackByUnit = (index: number, car: Vehicle): string | number => this.unitIdOf(car) ?? index;

  private get scopeCars(): Vehicle[] {
    const cars = this.cars ?? [];
    return this.scope === 'official' ? cars.filter((car) => car.bOfficial): cars;
  }

  private applyFilters(notifyMap = true): void {
    const scopeCars = this.scopeCars;
    const counts: Record<StatusFilter, number> = {
      all: scopeCars.length,
      active: 0,
      inactive: 0,
      area: 0,
    };
    for (const car of scopeCars) {
      const state = this.stateOf(car);
      if (state === 'active' || state === 'activeAlt') counts.active++;
      else if (state === 'inactive') counts.inactive++;
    }
    this.counts = counts;

    const isArea = this.statusFilter === 'area';
    const source = isArea ? this.areaCars : scopeCars;
    const term = normalize(this.searchTerm.trim());

    this.visibleCars = this.sorted(
      source.filter((car) =>
          (isArea || this.matchesStatus(car)) && (this.vehicleType === '-1' || String(car.tiMobileType) === this.vehicleType) &&
          (!term || [car.strFullName, car.strFullName2, car.strVehicleNo].some((v) => normalize(v).includes(term)))),
    );

    this.persistState();
    if (notifyMap) this.carGroup.emit(this.visibleCars);
  }

  private matchesStatus(car: Vehicle): boolean {
    const state = this.stateOf(car);
    switch (this.statusFilter) {
      case 'active':
        return state === 'active' || state === 'activeAlt';
      case 'inactive':
        return state === 'inactive';
      default:
        return true;
    }
  }

  private sorted(cars: Vehicle[]): Vehicle[] {
    switch (this.sortMode) {
      case 'name':
        return [...cars].sort((a, b) =>
          this.displayName(a).localeCompare(this.displayName(b), 'fa'),
        );
      case 'recent':
        return [...cars].sort((a, b) =>
          `${b.strDate ?? ''} ${b.strTime ?? ''}`.localeCompare(`${a.strDate ?? ''} ${a.strTime ?? ''}`),
        );
      case 'status':
        return [...cars].sort((a, b) => (a.tiDeviceStatus ?? 0) - (b.tiDeviceStatus ?? 0));
      default:
        return cars;
    }
  }

  // ======================= اطلاعات هر ردیف =======================
  stateOf(car: Vehicle): VehicleState {
    if (car.bOfficial) {
      switch (Number(car.tiOfficialStatus)) {
        case 1:
          return 'active';
        case 2:
          return 'activeAlt';
        default:
          return 'inactive';
      }
    }
    if (car.bNoMobileHistory) return 'noHistory';
    return car.bOnline ? 'active' : 'inactive';
  }

  stateLabel(car: Vehicle): string {
    return STATE_LABELS[this.stateOf(car)];
  }

  displayName(car: Vehicle): string {
    return (
      (car.bOfficial ? car.strFullName2 : car.strFullName) ||
      car.strFullName2 ||
      car.strFullName ||
      '—'
    );
  }

  plateOf(car: Vehicle): string {
    const raw = String(car.strVehicleNo ?? '');
    let plate = this.plateCache.get(raw);
    if (plate === undefined) {
      plate = this.otherService.returnCorrectPlate(raw);
      this.plateCache.set(raw, plate);
    }
    return plate;
  }

  unitIdOf(car: Vehicle | IAlarm): string | null {
    const unitId = (car as any)?.strUnitID ?? (car as any)?.strUnitId;
    return unitId ? String(unitId) : null;
  }

  flashOf(car: Vehicle): string | null {
    const id = this.unitIdOf(car);
    return (id && this.flashes.get(id)) || null;
  }

  isExpanded(car: Vehicle): boolean {
    return (this.expandedUnitId !== null && this.expandedUnitId === this.unitIdOf(car));
  }

  toggleDetails(car: Vehicle): void {
    const id = this.unitIdOf(car);
    this.expandedUnitId = this.expandedUnitId === id ? null : id;
  }

  // ======================= عملیات روی خودرو =======================

  async selectCar(car: Vehicle, index: number): Promise<void> {
    const unitId = car.strUnitID ?? car.strUnitId;
    this.selectedUnitId = this.unitIdOf(car);
    this.otherService.Showspinner();

    let data: any;
    try {
      const model = {
        ID: this.secret('ID'),
        strSession: this.secret('Session'),
        strUnitID: unitId,
      };
      ({ data } = await axios.post(`GetCar?strUnitID=${unitId}`, model));
    } catch {
      this.notifyService.showError('بروز خطا در سامانه');
      return;
    } finally {
      this.otherService.nonespinner();
    }

    if (data == null) {
      this.notifyService.showError('بروز خطا در سامانه');
      return;
    }

    if (data.ISSessionExpired == true) {
      this.otherService.removeLocalStorage();
      this.router.navigate(['login'], { queryParams: { error: '112' } });
      return;
    }

    Object.assign(car, {
      strDate: data.strDate,
      strTime: data.strTime,
      strTimeAge: data.strTimeAge,
    });

    this.locationTable.emit({
      item: { ...data, strIconName: car.strIconName },
      index,
    });
    this.carIdOut.emit(car.strUnitID);

    if (this.isMobile) this.close();
  }

  openDetailPage(car: Vehicle): void {
    this.stateManagement.filterItem_Management = this.visibleCars;
    this.router.navigate([`carInfo/${this.unitIdOf(car)}`]);
    this.hideMapTooltip();
  }

  openAreaAnalysis(car: Vehicle): void {
    if (String(this.GeoFence) === '-1') {
      this.notifyService.showInfo(
        'برای استفاده از این قابلیت ابتدا محدوده را مشخص کنید',
        'توجه',
      );
      return;
    }
    $('#modalPolygan').modal('show');
    this.analysisCarId = car.strUnitId || car.strUnitID || 0;
    this.carIdOut.emit({ strUnitId: this.analysisCarId, ...car });
  }

  // ======================= وقایع ردیاب =======================

  focusOnAlarm(alarm: IAlarm): void {
    this.locationTable.emit({ item: alarm, index: -1, type: 'alarm' });
  }

  openVehicleInfo(alarm: IAlarm): void {
    const tree = this.router.createUrlTree([
      '/carInfo',
      String(this.unitIdOf(alarm)).trim(),
    ]);
    window.open(this.router.serializeUrl(tree), '_blank');
    this.hideMapTooltip();
  }

  // ======================= (SignalR) =======================

  private watchHubConnection(): void {
    this.signalR.isHubConnected$
      .pipe(takeUntil(this.destroy$))
      .subscribe((connected: boolean) => {
        this.hubConnected = connected;
        this.listenToHub();
      });
  }

  private listenToHub(): void {
    if (this.hubListening) return;
    this.hubListening = true;

    const parse = <T>(payload: unknown): T => JSON.parse(String(payload)) as T;

    this.signalR.alarm$.pipe(takeUntil(this.destroy$)).subscribe((data: unknown) => {
        const alarm = parse<IAlarm>(data);
        this.ngZone.run(() => (this.alarms = [alarm, ...this.alarms].slice(0, MAX_ALARMS)));
      });

    this.signalR.locationChanged$.pipe(takeUntil(this.destroy$)).subscribe((data: unknown) =>
      this.queueLocationUpdates(parse<ILocationChanged>(data)),
    );

    this.signalR.locationChangedBatch$.pipe(takeUntil(this.destroy$)).subscribe((data: unknown) =>
      this.queueLocationUpdates(parse<ILocationChanged[]>(data)),
    );
  }

  private queueLocationUpdates(updates: ILocationChanged | ILocationChanged[]): void {
    for (const update of Array.isArray(updates) ? updates : [updates]) {
      this.pendingLocations.set(String(update.strUnitID), update);
    }
    if (this.flushTimer === undefined) {
      this.flushTimer = this.ngZone.runOutsideAngular(() =>
        setTimeout(() => this.flushLocationUpdates(), LOCATION_FLUSH_MS),
      );
    }
  }

  private flushLocationUpdates(): void {
    this.flushTimer = undefined;
    const updates = [...this.pendingLocations.values()];
    this.pendingLocations.clear();

    this.ngZone.run(() => {
      for (const update of updates) {
        const unitId = String(update.strUnitID);
        const cars = this.carsByUnitId.get(unitId);
        if (!cars) continue;

        const isAlert = update.tiDeviceStatus == 7;
        const patch = definedOnly({
          fLon: update.fLon,
          fLat: update.fLat,
          iSpeed: update.iSpeed,
          siAngle: update.iAngle,
          strDate: update.strDate,
          strTime: update.strTime,
          strTimeAge: update.strTimeAge,
          strUnitId: update.strUnitID,
          tiDeviceStatus: update.tiDeviceStatus,
          strDeviceStatus_strComment: isAlert
            ? update.strDeviceEventsType_strComment
            : update.strDeviceStatus_strComment,
        });

        cars.forEach((car) => Object.assign(car, patch));
        this.flash(unitId, isAlert ? 'alert' : 'ok');
      }
    });
  }

  private flash(unitId: string, kind: 'ok' | 'alert'): void {
    clearTimeout(this.flashTimers.get(unitId));
    // The sequence keeps the value changing so the highlight replays when the
    // same car is updated again before the previous one expired
    this.flashes.set(unitId, `${kind}-${++this.flashSeq}`);
    this.flashTimers.set(
      unitId,
      setTimeout(() => {
        this.flashes.delete(unitId);
        this.flashTimers.delete(unitId);
      }, FLASH_MS),
    );
  }

  private rebuildUnitIndex(): void {
    this.carsByUnitId.clear();
    for (const car of [...(this.cars ?? []), ...this.areaCars]) {
      const id = this.unitIdOf(car);
      if (!id) continue;
      const list = this.carsByUnitId.get(id);
      if (list) list.push(car);
      else this.carsByUnitId.set(id, [car]);
    }
  }

  // ======================= فراخوانی سرور =======================

  private async loadAreaCars(): Promise<void> {
    this.areaLoading = true;
    this.visibleCars = [];

    try {
      const model = this.otherService.stringNumberToNumber({
        strSession: this.secret('Session'),
        iSystemUser: this.secret('ID'),
        iGeoFence: this.GeoFence,
        bOfficial: this.scope === 'official',
      });
      const { data } = await axios.post('Radyab_GetMobileInGeoFence', model);
      this.areaCars = data ?? [];
    } catch {
      this.areaCars = [];
      this.notifyService.showError('بروز خطا در سامانه');
    } finally {
      this.areaLoading = false;
    }

    if (this.statusFilter === 'area') {
      this.rebuildUnitIndex();
      this.applyFilters();
    }
  }

  private async loadVehicleTypes(): Promise<void> {
    try {
      const { data } = await axios.post('GetMobileType', {});
      this.vehicleTypes = data ?? [];
    } catch {
      this.vehicleTypes = [];
    }
  }

  private async loadCarCount(): Promise<void> {
    try {
      const { data } = await axios.post('GetCarCount', {
        strSession: this.secret('Session'),
        Id: this.secret('ID'),
        strUnitID: '',
      });
      this.carCount = Number(data);
    } catch {
      return;
    }

    if (this.carCount === -1) {
      $.confirm({
        title: 'خودرویی برای شما ثبت نشده است آیا مایل به ثبت خودرو هستید؟',
        content: '',
        type: 'blue',
        buttons: {
          ok: {
            text: 'بله هستم',
            btnClass: 'btn-success',
            keys: ['enter'],
            action: () => $('#exampleModal').modal('show'),
          },
          cancel: { text: 'خیر نیستم' },
        },
      });
    }
  }

  // ======================= خروجی اکسل =======================

  exportExcel(): void {
    const rows =
      this.scope === 'alarms'
        ? this.alarms.map((alarm: any, i) => ({
            ردیف: i + 1,
            عنوان: alarm.strMessage ?? 'نامشخص',
            تاریخ: alarm.strDate,
            زمان: alarm.strTime,
          }))
        : this.visibleCars.map((car, i) => ({
            ردیف: i + 1,
            وضعیت: this.stateLabel(car),
            راننده: this.displayName(car),
            'آخرین بروزرسانی': car.strTimeAge,
            'وضعیت دستگاه': car.strDeviceStatus_strComment,
            پلاک: car.strVehicleNo,
            Imei: this.unitIdOf(car),
            'حوزه خدمت': car.strMobileDomain_strComment,
            'گروه خودرو': car.strMobileGroup_strComment,
            'نوع خودرو': car.strMobileType_strComment,
            'عرض جغرافیایی': car.fLat,
            'طول جغرافیایی': car.fLon,
          }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      XLSX.utils.json_to_sheet(rows),
      'Sheet1',
    );
    XLSX.writeFile(workbook, EXPORT_FILE_NAME);
  }

  // ======================= مودال‌های بیرونی (jQuery) =======================

  private bindExternalModalEvents(): void {
    $('#reporetArea').on('click.menuCar', () => this.saveReportRangeAndOpen());

    $('#enterAnimateArea').on('click.menuCar', () => {
      $('#carMoveAreaModal').modal('hide');
      (window as any)
        .open(`/route/${this.analysisCarId}/${this.GeoFence}`, '_blank')
        .focus();
      this.store('RouteDate', this.dataPolygans.value.date);
    });

    $('[name="analysis"]').on('click.menuCar', (e: any) => {
      $('#modalPolygan').modal('hide');
      this.hideMapTooltip();
      $('#exampleModalreportArea').modal('show');

      if (e.target.id === 'enterExit') this.reportType = 11;
      if (e.target.id === 'analysisArea') this.reportType = 10;
    });
  }

  private saveReportRangeAndOpen(): void {
    const startTime = document.getElementById('clocks') as HTMLInputElement;
    const endTime = document.getElementById('clocke') as HTMLInputElement;

    this.store('reportDataZa', this.dataWorkAz.value.date);
    this.store('reportDataTa', this.dataWorkTa.value.date);
    this.store('reportStime', startTime.value);
    this.store('reportEtime', endTime.value);

    $('#exampleModalreportArea').modal('hide');

    if (this.reportType) {
      this.router.navigate([
        `report/${this.analysisCarId}/${this.reportType}/${this.GeoFence}`,
      ]);
    }
  }

  // ======================= متفرقه =======================

  openGuide(): void {
    this.otherService.guid(34);
  }

  close(): void {
    this.host.nativeElement.classList.add('d-none');
    document.getElementById('bg-menu')?.classList.add('d-none');
  }

  private secret(key: string): string {
    return this.gurdService.decrypt(window.localStorage.getItem(key)!);
  }

  private store(key: string, value: any): void {
    window.localStorage.setItem(key, this.gurdService.encrypt(value));
  }

  private hideMapTooltip(): void {
    $('#map_tooltip').tooltip('hide');
  }

  private restoreState(): void {
    const saved = this.stateManagement;
    this.scope = saved.bOfficial ? 'official' : 'all';
    this.statusFilter = RADIO_ID_STATUS[saved.radioButton_Management] ?? 'all';
    this.vehicleType = saved.selectBox_Management ?? '-1';
    this.searchTerm = saved.searchKey_Management ?? '';
    this.visibleCars = saved.filterItem_Management ?? [];
    this.hasRestoredState = this.visibleCars.length > 0;
  }

  private persistState(): void {
    const state = this.stateManagement;
    state.bOfficial = this.scope === 'official';
    state.filterItem_Management = this.visibleCars;
    state.radioButton_Management = STATUS_RADIO_ID[this.statusFilter];
    state.selectBox_Management = this.vehicleType;
    state.searchKey_Management = this.searchTerm;
  }
}
